var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkBlock1Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 5V71.9619H71.185V17.0203L40.0044 5ZM65.5805 58.5803H45.9274V52.2997H65.5805V58.5803ZM65.5805 46.0222H45.9274V39.7446H65.5805V46.0222ZM65.5805 33.464H45.9274V27.1864H65.5805V33.464Z",
    fill: "#1D4B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0294 71.9529H8.914V23.5382L37.0294 20.3709V71.9529ZM10.3534 70.5134H35.587V21.9816L10.3534 24.8244V70.5134Z",
    fill: "#1D4B48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3534 19.3342H8.914V75H10.3534V19.3342Z",
    fill: "#1D4B48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3082 70.5134H5.86687V71.9529H36.3082V70.5134Z",
    fill: "#1D4B48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1331 70.5134H40.0014V71.9529H74.1331V70.5134Z",
    fill: "#1D4B48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0264 16.3291H35.587V75H37.0264V16.3291Z",
    fill: "#1D4B48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.182 12.4225H69.7425V75H71.182V12.4225Z",
    fill: "#1D4B48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0545 28.713H19.615V66.09H21.0545V28.713Z",
    fill: "#1D4B48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7777 61.1977H5.86687V62.6372H24.7777V61.1977Z",
    fill: "#1D4B48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3082 51.882H16.054V53.3215H36.3082V51.882Z",
    fill: "#1D4B48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3082 32.7127H16.054V34.1521H36.3082V32.7127Z",
    fill: "#1D4B48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7777 42.5663H5.86687V44.0058H24.7777V42.5663Z",
    fill: "#1D4B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkBlock1Ic);
export default __webpack_public_path__ + "static/media/workBlock1_ic.44ec6a7e9e040df8b7d1158e868855bf.svg";
export { ForwardRef as ReactComponent };